import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@material-ui/core';
import Dialog from '@material-ui/core/Dialog';
import { IconButton} from '@coolremote/shared';
import React, { useMemo } from 'react';
import { t } from 'ttag';
import clsx from 'clsx';
import { Close } from '@icons';
import useStyles from './style';
import { useStoreState } from '@models/RootStore';

const AlertCategoryPopUp = (props) => {
  const { open, filterdAlertsCounts, alertFilterType, onClose } = props;
  const classes = useStyles();
  const eventCategoriesData = useStoreState(
    (state) => state.types.eventCategoriesData
  );

  const totalEventCount = useMemo(() => {
    return filterdAlertsCounts.reduce((sum, item) => sum + item.eventCount, 0);
  }, [filterdAlertsCounts]);

  const filterType = useMemo(() => {
    return Object.values(eventCategoriesData).find(
      (item) => item.id === alertFilterType
    );
  }, [eventCategoriesData, alertFilterType]);

  const handleAlertCardClick = (siteId, filterKey) => {
    window.open(
      `${window.location.origin}/alerts/site/${siteId}/filterType/${filterKey}`,
      '_blank'
    );
  };

  return (
    <div>
      <Dialog
        open={open}
        onClose={onClose}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        maxWidth="lg"
        fullWidth
        classes={{ paper: classes.dialogWidth }}
      >
        <div className={classes.titleContent}>
          <div className={classes.alertNameHolder}>
            <Typography
              className={classes.alertCount}
              style={{ color: filterType?.color }}
            >
              {totalEventCount < 10 ? '0' + totalEventCount : totalEventCount}
            </Typography>
            <span className={classes.alertName}>
              {' '}
              {filterType?.name || alertFilterType}
            </span>
          </div>
          <IconButton
            disableRipple
            onClick={onClose}
            className={classes.iconBtnStyle}
          >
            <Close color="#7f7692" />
          </IconButton>
        </div>
        <div className={classes.dialogContent}>
          <TableContainer className={classes.tableWrapper}>
            <Table stickyHeader aria-label="a dense table">
              <TableHead>
                <TableRow>
                  <TableCell
                    classes={{ root: classes.tableHeadCell }}
                  >{t`Site Name`}</TableCell>
                  <TableCell
                    align="center"
                    classes={{ root: classes.tableHeadCell }}
                  >{t`Alerts`}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {filterdAlertsCounts.map((alert) => (
                  <TableRow key={`${alert.siteId}-${alert.filterType}`}>
                    <TableCell classes={{ root: classes.tableRowCell }}>
                      {alert.name}
                    </TableCell>
                    <TableCell
                      classes={{
                        root: clsx(classes.tableRowCell, classes.link),
                      }}
                      align="center"
                      onClick={() =>
                        handleAlertCardClick(alert.siteId, alert.filterType)
                      }
                    >
                      {alert.eventCount}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </div>
      </Dialog>
    </div>
  );
};

export default AlertCategoryPopUp;
